import { IInputBaseProps, InputBase } from "./base";

interface IProps extends Omit<IInputBaseProps, "type"> {
  name: string;
}

export function InputHidden({ ...props }: IProps) {
  return <InputBase {...props} type="hidden" />;
}
